import { render, staticRenderFns } from "./delivery_by_origins.vue?vue&type=template&id=3b27f81c&scoped=true"
import script from "./delivery_by_origins.vue?vue&type=script&lang=js"
export * from "./delivery_by_origins.vue?vue&type=script&lang=js"
import style0 from "./delivery_by_origins.vue?vue&type=style&index=0&id=3b27f81c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27f81c",
  null
  
)

export default component.exports